export enum USER_SETTINGS_GROUPS {
  PREFERENCES = 'Preferences',
  CERTIFICATES = 'Certificates',
  DEVELOPER = 'Developer',
  NOTIFICATIONS = 'Notifications',
}

export const USER_SETTINGS_CONSTANTS = {
  ORGANIZATIONS: {
    ROUTE: 'organizations',
    LABEL: 'Organizations',
  },
  ACCOUNT_SECURITY: {
    ROUTE: 'account-security',
    LABEL: 'Account Security',
  },
  PERSONAL_INFORMATION: {
    ROUTE: 'personal-information',
    LABEL: 'Personal Information',
  },
  TOKEN_MANAGEMENT: {
    ROUTE: 'token-management',
    LABEL: 'Token Management',
  },
  INBOX: {
    ROUTE: 'inbox',
    LABEL: 'Inbox',
  },
};
